import React from "react";
import {WalkthroughCore} from "./Walkthrough";
import {TrailWalkthroughStep} from "./WalkthroughStep";

const TrailWalkthrough = props => {
    const {step, stepActivity, continueCurrentStep} = props;

    if (!step || !stepActivity) {
        return;
    }

    return (
        <WalkthroughCore
            questionId={stepActivity.questionId}
            conceptId={step.conceptId}
            trailStepId={step.stepId}
            className="ch-trail-walkthrough"
            StepComponent={TrailWalkthroughStep}
            stepComponentProps={{trailStepId: step.stepId}}
            showWalkthroughCompleteBtn={true}
            onWalkthroughComplete={continueCurrentStep}
        />
    )
};

export default TrailWalkthrough;